var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 32.935c8.837 0 16-7.134 16-15.934 0-8.8-7.163-15.935-16-15.935S1 8.2 1 17.001c0 8.8 7.163 15.934 16 15.934z",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.289 23.991c-.097-1.07-.06-1.817-.06-2.795.487-.254 1.359-1.875 1.506-3.245.383-.031.986-.403 1.163-1.87.095-.789-.284-1.232-.514-1.372.622-1.865 1.916-7.634-2.392-8.23-.444-.776-1.579-1.168-3.054-1.168-5.903.108-6.615 4.439-5.321 9.398-.23.14-.609.583-.514 1.371.177 1.468.78 1.84 1.163 1.871.146 1.37 1.053 2.991 1.541 3.245 0 .978.037 1.725-.06 2.795-.841 2.251-5.159 2.427-7.65 4.598 2.605 2.61 6.825 4.478 11.278 4.478s9.688-3.501 10.56-4.457c-2.476-2.19-6.803-2.36-7.646-4.619z",
    fill: "#A1A1A1"
  })));
}

export default SvgUserCircle;